import Image from 'next/image'
import { ENTITY } from 'src/consts'
import { Icon } from 'src/components/Icon'
import styles from './styles.module.scss'
import clsx from 'clsx'

export const TopInfoBlock = ({ data }) => {
  const { index, type, coreType, name, slug, symbol } = data

  const colors = {
    centralized: 'green',
    decentralized: 'gray',
    verified: 'dark-gray',
    index: 'default',
  }
  return (
    <div className={styles.container}>
      <div className={styles.iconContainer}>
        <Icon
          data={{ name, slug, symbol }}
          size='48x48'
          entity={ENTITY.EXCHANGE}
        />
      </div>
      <div className={styles.symbol}>
        <h1 className={styles.symbolTitle}>{name}</h1>
        <div className={styles.symbolInfo}>
          <div className={clsx(styles.infoItem, styles[colors.index])}>
            #{index}
          </div>
          <div
            className={clsx(
              styles.infoItem,
              styles[colors[coreType.toLowerCase()]]
            )}
          >
            {coreType.toUpperCase()}
          </div>
          <div className={clsx(styles.infoItem, styles[colors.verified])}>
            {type.toLowerCase() === 'verified' && (
              <div className={styles.verifiedIcon}>
                <Image
                  src='/assets/icons/icon-check.svg'
                  width='10'
                  height='10'
                  alt='Icon check'
                />
              </div>
            )}
            {type.toUpperCase()}
          </div>
        </div>
      </div>
    </div>
  )
}

export default TopInfoBlock
